import typeCheck from 'common/util/typeCheck';

import { SR_API_ACTION_LISTING_CALL_BUTTON_CLICK } from 'api/actionTypes';

export default async function callButtonClick({ apiClient }, listingId) {
  typeCheck('listingId::PositiveNumber', listingId);
  await apiClient.post(SR_API_ACTION_LISTING_CALL_BUTTON_CLICK, { listingId });
}
